const PATIENT_SALUTATIONS = new Set(["Mr.", "Mrs.", "Ms.", "Miss", "Mme.", "Prof."]);

function text(value) {
  return String(value || "").trim();
}

function familyName(...sources) {
  for (const source of sources) {
    const explicit = text(source?.last_name || source?.family_name || source?.surname);
    if (explicit) return explicit;
    const parts = text(source?.full_name || source?.display_name || source?.name).split(/\s+/).filter(Boolean);
    if (parts.length > 1) return parts.at(-1);
  }
  return "";
}

/** Canonical patient-facing self-identity: salutation + family name when available. */
export function resolvePatientDisplayName({ profile = null, user = null, fallback = "Patient" } = {}) {
  const metadata = user?.user_metadata || {};
  const salutation = text(profile?.salutation || metadata?.salutation);
  const surname = familyName(profile, metadata, { full_name: fallback });
  if (PATIENT_SALUTATIONS.has(salutation) && surname) return `${salutation} ${surname}`;
  return text(fallback) || "Patient";
}
